import { MutableRefObject } from 'react'
import {
  APPROVAL_TYPE,
  ATTACHMENT_DESCRIPTION_TYPE,
  ATTACHMENT_EXTRAFIELD,
  ATTACHMENT_TYPE,
  MEDIA_DATA_TYPE,
  POST_SOCIAL_STATUS,
  POST_TYPE,
  SOCIAL_NETWORK,
  TApproval,
  TApprovalAction,
  TApprovalPlan,
  TAttachmentExtraFieldValues,
  TPost,
  TPostAction,
  TPostAttachment,
  TPostSchedule,
  TPostSocial,
  TPostSocialNote,
  TSocialMention,
  TSocialHashtag,
  TSocialLocation,
  TShortenLink
} from '../../models/post'

export enum QUESTION_ANSWER_FORM_TYPE {
  TYPE_QUESTION = 'type-question',
  TYPE_ANSWER = 'type-answer'
}

export enum VIEW_TYPE {
  TYPE_DESKTOP = 'desktop',
  TYPE_MOBILE = 'mobile',
  TYPE_GRID = 'grid'
}

export enum ChangeFieldName {
  ID = 'id',
  POST_ID = 'post_id',
  FIRST_COMMENT = 'first_comment',
  MESSAGE = 'message',
  SOCIAL_NETWORK = 'social_network'
}

export type TExtendedPostAttachment = TPostAttachment & {
  toRemove?: boolean
  toUpdate?: boolean
  toCopy?: boolean
  toAddVideoTumbnail?: boolean
  toRemoveVideoTumbnail?: boolean
  toUpdateVideoTumbnail?: boolean
  toDeatachMedia?: boolean
  temporaryId?: number
}

export type TPostSocialManagePost = TPostSocial & {
  attachments: TExtendedPostAttachment[]
  isEditable: boolean
  isRemoveAllAttachments?: boolean
  last_social_api_response: any
  hashtag?: any
  geolocation?: any
  shorten_link?: any 
}

export type TPostForApproval = TPost & {
  postSocials: TPostSocialManagePost[]
  schedule: TLatestSchedule
}

export type TPostSocialNoteForList = TPostSocialNote & {
  ref: MutableRefObject<HTMLTextAreaElement | null>
  disabled: boolean
}

export type TPostSocialsNotesMapByPostSocialId = {
  [key in number]: TPostSocialNote[]
}

export type TNewPostSocialNotePayload = {
  message: string
  post_social_id: number
  attachments?: Array<any>
}

export type TPostSocialNoteDeletedDataPayload = {
  post_social_id: number
  note_id: number
}

export type TPostSocialNoteUpdatedDataPayload = TPostSocialNoteDeletedDataPayload & {
  message: string
  attachments?:Array<any>
}

export type TRequireApproverRevisionPayload = {
  approval_id: number
  message: string
  checkboxes: TNewCheckbox[]
  post_social_id: number
  post_id: number
  isMasterContent?: boolean
  attachments:Array<any>
  type:string
}

export type TPushQuestionByContentCreatorPayload = {
  approval_id: number
  message: string
  post_social_id: number
}

export type TPushAnswerByApproverPayload = {
  approval_id: number
  message: string
  post_social_id: number
}

export type TUpdatePostSchedulePayload = {
  date: string
  time: string
  is_autoposting: boolean
  schedule_id: number
}

export type TUpdatePostSchedulesPayload = {
  date: string
  time: string
  is_autoposting: boolean
  schedule_ids: number[]
}

export type TStartNextApprovalRoundPayload = {
  post_social_id: number
}

export type TDeleteTemporaryMediaPayload = {
  project_id: number
  media_id: number
}

export type TImportCanvaPayload = {
  canva_design_id: string
  content_url: string
}

export type TNewCheckbox = {
  label?: string
  is_checked: boolean
}

export type TApproveCheckbox = TNewCheckbox & {
  id: number
}

export type TStatusesCheckboxesPayload = {
  approval_id: number
  approval_action_id: number
  checkboxes: TApproveCheckbox[]
  post_social_id: number
}

export type TApproveCurrentRoundPayload = {
  post_social_id: number
  approval_id?: number
}

export type TUnApproveCurrentRoundPayload = {
  approval_id: number
}

export type TApprovalPostSocialsManagePost = {
  id: number
  is_master_content: boolean
  status: POST_SOCIAL_STATUS
  is_approved:boolean
  is_unapproved:boolean
  internal_approval_id?:number
  external_approval_id?:number
  approvals: (TApproval & {
    actions: TApprovalAction[]
  })[]
}

export type TPostSocialsActionsMapByPostSocialId = {
  [key in number]: {
    aprrovalActions: TApprovalAction[]
    [APPROVAL_TYPE.TYPE_INTERNAL]: TApprovalAction[]
    [APPROVAL_TYPE.TYPE_EXTERNAL]: TApprovalAction[]
    questionAnswerHistoryByApprovalId: {
      [key in number]: TApprovalAction[]
    }
    lastApprovalId: number
  }
}

export type TFieldChangePayload = {
  socialNetwork: SOCIAL_NETWORK
  value: string | number
  field: ChangeFieldName
  rawValue?: string
}

export type TImagesChangePayload = {
  social: SOCIAL_NETWORK
  images: any[]
}

export type TRemoveAttachmentPayload = {
  id: number
  temporaryId: number | undefined
}

export type TPageFansPayload = {
  socialNetwork: SOCIAL_NETWORK
  projectId: number
  date?: string
}

export type TLatestSchedule = Pick<TPostSchedule, 'id' | 'is_autoposting' | 'timezone'> & {
  date: string
  time: string
  datetime: string
}

export type TAttachmentIds = {
  id: number
  temporaryId: number | undefined
}

export type TAddImageToLinkAttachmentPayload = Pick<TAttachmentIds, 'id' | 'temporaryId'> & {
  media: MEDIA_DATA_TYPE
}

export type TAddVideoThumbnailAttachmentPayload = Pick<TAttachmentIds, 'id' | 'temporaryId'> & {
  media: MEDIA_DATA_TYPE
}

export type TSetPostSocialExtrafieldPayload = {
  social: SOCIAL_NETWORK
  mention: TSocialMention
}
export interface IManagePostState {
  viewType: VIEW_TYPE
  post: TPost
  latestSchedule: TLatestSchedule
  postSocials: TPostSocialManagePost[]
  postActions: TPostAction[]
  postSocialsApprovalActions: TPostSocialsActionsMapByPostSocialId
  postSocialNotes: TPostSocialsNotesMapByPostSocialId
  approval: {
    approval_plan: TApprovalPlan
    post_socials: TApprovalPostSocialsManagePost[],
    current_user_id:number
  }
  availablePostTypes: POST_TYPE[]
  selectedSocials: SOCIAL_NETWORK[]
  selectedPostType: POST_TYPE
  selectedSocial: SOCIAL_NETWORK
  selectedPostSocialId: number
  linkCarouselSelectedAttachmentIds: TAttachmentIds
  selectedPostsToApproval: number[]
  availableSocialNetworks: SOCIAL_NETWORK[]
  error: any
  loaders: TLoadersManagePost
  isExistChanges: boolean
  isGettingPostError: boolean
  postDetails :Array<{}>
  resultTags :Array<{}>
  resultFacebookMentions :Array<{}>
  resultLinkedInMentions :Array<{}>
  resultTwitterMentions :Array<{}>
  resultgeolocations :Array<{}>
  shortenLink: string
}

export type TLoadersManagePost = {
  approval: {
    loading: boolean
    requestRevision: boolean
    saveQuestionOrAnswer: boolean
    requestQty: number
  }
  schedules: {
    delete: boolean
    update: boolean
  }
  post: {
    save: boolean
    delete: boolean
    loadingTypes: boolean
    approve: boolean
    copyAttachments: boolean
    skipApproval:boolean
    processingIds: number[]
  }
  note: {
    save: boolean
    delete: boolean
    processingIds: number[]
  }
}

export type TAddLinkToSocialAttachmentPayload = {
  isChildLink: boolean
}

export type TChangeAttachmentExtrafieldPayload = {
  field: ATTACHMENT_EXTRAFIELD
  id?: number
  temporaryId?: number
  value: TAttachmentExtraFieldValues
}

const emptyPostSocial: TPostSocialManagePost = {
  id: 0,
  post_id: 0,
  social_network: SOCIAL_NETWORK.FACEBOOK_SOCIAL,
  message: '',
  type: POST_TYPE.POST_TYPE_SINGLE_PHOTO,
  status: POST_SOCIAL_STATUS.STATUS_DRAFT,
  attachment_order: [],
  attachments: [],
  first_comment: '',
  extra_fields: {},
  has_multi_attachments: false,
  created_at: '',
  updated_at: '',
  deleted_at: '',
  isEditable: true,
  last_social_api_response: null,
  is_unapproved:false,
  location: ''
}

export const createEmptyAttachment = (url: string): TExtendedPostAttachment => ({
  id: 0,
  temporaryId: 0,
  post_social_id: 0,
  object_data: createEmptyAttachmentObjectDataWithImage(url),
  object_id: 0,
  object_type: ATTACHMENT_TYPE.TYPE_IMAGE,
  description: ATTACHMENT_DESCRIPTION_TYPE.MEDIA,
  thumbnail_object_data: null,
  thumbnail_object_id: null,
  preview_image_id: 0,
  created_at: '',
  updated_at: '',
  toUpdate: false
})

const createEmptyAttachmentObjectDataWithImage = (url: string): MEDIA_DATA_TYPE => ({
  content_type: '',
  file_path: '',
  file_size: 0,
  id: 0,
  options: {
    height: 100,
    ratio: '1:1',
    type: ATTACHMENT_TYPE.TYPE_IMAGE,
    width: 100
  },
  is_temporary: true,
  media_collection_type: '',
  parent_media_id: 0,
  original_name: '',
  public_url: url,
  user_id: 0,
  canva_design_id: null
})

export const createEmptyPostSocialsBySelectedSocials = (
  selectedSocials: SOCIAL_NETWORK[],
  postType: POST_TYPE
): TPostSocialManagePost[] => {
  return selectedSocials.map<TPostSocialManagePost>((social, index) => {
    return {
      ...emptyPostSocial,
      id: index,
      social_network: social,
      type: postType
    }
  })
}

export type TSetPostSocialHashtagPayload = {
  social: string
  hashtag: TSocialHashtag
}

export type TSetPostSocialGeolocationPayload = {
  social: string
  location: TSocialLocation
}

export type TSetPostShortenLinkPayload = {
  social: SOCIAL_NETWORK
  link: TShortenLink
}